type SavedProduct = {
    type: string;
    slug: string;
    productId: number;
};
export const useSearchedProducts = () => {
    const saveSearchedProduct = ({ type, slug, productId }: SavedProduct) => {
        const existingProducts = JSON.parse(localStorage.getItem('searchedProducts') || '[]');
        const newProduct = { type, slug, productId };
        const updatedProducts = [newProduct, ...existingProducts.filter((product) => product.productId !== productId)];
        localStorage.setItem('searchedProducts', JSON.stringify(updatedProducts));
    };

    const searchedProducts = JSON.parse(localStorage.getItem('searchedProducts') || '[]') as SavedProduct[];

    return {
        saveSearchedProduct,
        searchedProducts,
    };
};
